// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"486aef52e1616078ed21","883":"69f260d9d7f325edf78a"}[chunkId] + ".js";
};